// extracted by mini-css-extract-plugin
export var clickableWrapper = "_32-2";
export var placeholderIcon = "_32-3";
export var thumbnailCanvas = "_32-1";
export var thumbnailWrapper = "_32-0";